module.exports = __webpack_public_path__ + "static/img/10areaB_02.09ca5bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/10areaB_02.png
// module id = 1081
// module chunks = 1